import React, { useState } from 'react'
import { Checkbox, IconButton, InputAdornment, TextField } from '@mui/material'
import { color } from '@trivie/ui-web/theme'
import { Delete } from '@mui/icons-material'
import { observer } from 'mobx-react-lite'

export const OpenText = observer((props: any) => {
  const { question } = props

  const [hovered, setHovered] = useState<any>()

  const textSx = {
    '& .MuiInputBase-root': {
      textDecoration: 'none',
      fontSize: 14,
      fontFamily: 'Inter',
      fontWeight: 500,
      paddingRight: '80px',
      lineHeight: '16.94px',
      paddingTop: '8px',
      paddingBottom: '8px',
      pointerEvents: 'auto',
      paddingLeft: '20px',
    },
  }

  const handleBackspace = (e) => {}

  return question.choices.map((choice, index) => {
    return (
      <div style={CONTAINER}>
        <TextField
          onKeyDown={(e) => {
            if (
              question?.choices.length > 2 &&
              (choice.text === '' || choice.text === null) &&
              e.key === 'Backspace'
            ) {
              question?.removeChoice(choice)
            }
          }}
          onMouseEnter={() => setHovered(choice)}
          onMouseLeave={() => setHovered(null)}
          sx={{
            ...textSx,
            '& .MuiInput-underline:after': {
              borderBottomColor: choice?.generating
                ? color.lightPurple
                : choice.touched && choice.formErrors.text
                  ? color.red
                  : choice.formWarnings.text
                    ? color.yellow
                    : color.blue,
            },
            '& .MuiInput-underline:before': {
              borderBottomColor: choice?.generating
                ? color.lightPurple
                : choice.touched && choice.formErrors.text && !question?.generatingAll
                  ? color.red
                  : choice.formWarnings.text && !question?.generatingAll
                    ? color.yellow
                    : color.shade10,
            },
          }}
          style={{ width: '100%' }}
          value={choice.text}
          variant="standard"
          placeholder={`Correct Answer ${index + 1}`}
          inputProps={{ 'aria-label': 'Correct Answer 1' }}
          onChange={(e) => {
            choice.setTouched(true)
            choice.setText(String(e.target.value))
          }}
          InputProps={{
            startAdornment: (
              <Checkbox
                checked
                inputProps={{ 'aria-label': 'choice' }}
                disabled
                style={{
                  placeSelf: 'center',
                  marginRight: 25,
                  //   color: choice.correct ? color.shade70 : color.shade30,
                }}
              />
            ),
            endAdornment: (
              <InputAdornment position="end" style={{ position: 'absolute', right: 0 }}>
                <div style={{ flexDirection: 'row', cursor: 'pointer' }}>
                  {question?.choices.length > 1 && hovered === choice && (
                    <IconButton
                      sx={{
                        '&:hover': {
                          svg: { color: color.shade50, transition: 'color .5s' },
                        },
                      }}
                      style={{ marginRight: 2 }}
                      onClick={() => question?.removeChoice(choice)}
                    >
                      <Delete style={{ fontSize: 18 }} htmlColor={color.shade30} />
                    </IconButton>
                  )}
                </div>
              </InputAdornment>
            ),
          }}
        />
      </div>
    )
  })
})

const CONTAINER: React.CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
}
const HANDLE: React.CSSProperties = {
  color: color.shade10,
  alignSelf: 'center',
  fontSize: 20,
}
